import React from "react";
import { ReactComponent as HtmlSvg } from "./html.svg";
import { ReactComponent as CSSSvg } from "./css.svg";
import { ReactComponent as JSSvg } from "./javascript.svg";
import { ReactComponent as ReactSvg } from "./react.svg";
import { ReactComponent as NodeSvg } from "./node.svg";
import { ReactComponent as SpringSvg } from "./spring.svg";
import { ReactComponent as NextSvg } from "./next.svg";
import { ReactComponent as GraphqlSvg } from "./graphql.svg";
import { ReactComponent as WebpackSvg } from "./webpack.svg";
import { ReactComponent as SqlSvg } from "./sql.svg";
import { ReactComponent as PsqlSvg } from "./psql.svg";
import { ReactComponent as CSvg } from "./c.svg";
import { ReactComponent as SocketIoSvg } from "./socket-io.svg";
import { ReactComponent as JavaSvg } from "./java.svg";
import { ReactComponent as GitSvg } from "./git-svg.svg";
import { ReactComponent as GitHubSvg } from "./github.svg";
import { ReactComponent as VsCodeSvg } from "./vs.svg";
import { ReactComponent as IntelliSvg } from "./intellij.svg";
import { ReactComponent as TypeScriptSvg } from "./typescript.svg";
const LangSvg = ({ lang, className }) => {
  switch (lang) {
    case "html":
      return <HtmlSvg className={className} />;
    case "css":
      return <CSSSvg className={className} />;
    case "js":
      return <JSSvg className={className} />;
    case "typescript":
      return <TypeScriptSvg className={className} />;
    case "socket":
      return <SocketIoSvg className={className} />;
    case "react":
      return <ReactSvg className={className} />;
    case "node":
      return <NodeSvg className={className} />;
    case "spring":
      return <SpringSvg className={className} />;
    case "next":
      return <NextSvg className={className} />;
    case "graphql":
      return <GraphqlSvg className={className} />;
    case "webpack":
      return <WebpackSvg className={className} />;
    case "sql":
      return <SqlSvg className={className} />;
    case "psql":
      return <PsqlSvg className={className} />;
    case "c":
      return <CSvg className={className} />;
    case "java":
      return <JavaSvg className={className} />;
    case "git":
      return <GitSvg className={className} />;
    case "github":
      return <GitHubSvg className={className} />;
    case "vscode":
      return <VsCodeSvg className={className} />;
    case "intelli":
      return <IntelliSvg className={className} />;

    default:
      break;
  }
};

export default LangSvg;
